import * as React from 'react';

import './Block.scss';

export const BlockSvg = ({ url }: any) => (
  <div className="block-image">
    <img src={url} style={{ width: '100%' }} />
  </div>
);
